import React from 'react';
import PropTypes from "prop-types";
import {Link} from "react-router-dom";

import './header.scss';

function Header(
    {
        main_menu,
        user_menu
    }
) {
    return (
        <div id='mindsets-header'>
            <div className='mindsets-header-container'>
                <div className='mindsets-header-content'>
                    <Link to="/" className="mindsets-header-logo">
                        <img
                            src={process.env.PUBLIC_S3_ASSETS_URL + "/logos/mindsets_logo_white.svg"}
                            alt="Mindsets Learning Inc."
                        />
                    </Link>
                    <div className='mindsets-header-menu-laptop'>
                        {main_menu}
                    </div>
                    <div className='mindsets-header-menu-phone-wrapper'>
                        <div className='mindsets-header-menu-phone'>
                            {main_menu}
                        </div>
                        {user_menu}
                    </div>
                </div>
            </div>
        </div>
    );
}

Header.propTypes = {
    main_menu: PropTypes.element,
    user_menu: PropTypes.element,
};

export default Header;
